import React from 'react'
import { get, find } from 'lodash'
import pageStore from '~/redux/page/store'
import Carousel from '~/modules/Carousel'
import Headlines from '~/components/Headlines'
import AD from 'react-google-publisher-tag';
import './styles.css'


class ModulesContainer extends React.Component {
  render(){
    const page = pageStore.getState()
    const background = get(this.props, 'layout.settings.backgroundColor')
    const carouselData = find(page.data.modules, (data) => { return data.id === this.props.data.moduleIds[0]})
    const headlinesData = find(page.data.modules, (data) => { return data.id === this.props.data.moduleIds[1] })
    const adData = find(page.data.modules, (data) => { return data.id === this.props.data.moduleIds[2] })
    return(
      <div className="modules-container">
        <div className="carousel-container">
          <Carousel data={carouselData}/>
        </div>
        <div className="headlines-container" style={{ background: background }}>
          <h2><span>{headlinesData.title}</span></h2>
          <Headlines data={headlinesData}/>
          <div className="reactangle-ad">
            <AD path={get(adData, 'metadataMap.adTag')} dimensions={[[300, 250]]} />
          </div>
        </div>
      </div>
    )
  }
}

export default ModulesContainer